import { createSlice } from "@reduxjs/toolkit";
import {
  GetAllUsersData,
  NPResourceInitialStatus,
} from "../../../../types/redux/NP/resource";
import {
  createUserAsync,
  getAllUsersAsync,
  getCountUsersAsync,
  userUpdatePasswordAsync,
} from "./resourceAPI";

const initialState: NPResourceInitialStatus<GetAllUsersData> = {
  loading: false,
  postLoading: false,
  updateLoading: false,
  deleteLoading: false,
  updatePasswordLoading: false,
  allUsers: [],
  usersCount: {
    totalAmount: 0,
    totalMinutesOfWork: 0,
    totalUsers: 0,
  },
};

const resourceSlice = createSlice({
  name: "np-resource",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // create user
    builder
      .addCase(createUserAsync.pending, (state) => {
        state.postLoading = true;
      })
      .addCase(createUserAsync.fulfilled, (state) => {
        state.postLoading = false;
      })
      .addCase(createUserAsync.rejected, (state) => {
        state.postLoading = false;
      });
    // get all users
    builder
      .addCase(getAllUsersAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllUsersAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.allUsers = action.payload;
      })
      .addCase(getAllUsersAsync.rejected, (state) => {
        state.loading = false;
        state.allUsers = [];
      });
    // get users count
    builder
      .addCase(getCountUsersAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCountUsersAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.usersCount = action.payload;
      })
      .addCase(getCountUsersAsync.rejected, (state) => {
        state.loading = false;
        state.usersCount = {
          totalAmount: 0,
          totalMinutesOfWork: 0,
          totalUsers: 0,
        };
      });

    // update user password
    builder
      .addCase(userUpdatePasswordAsync.pending, (state) => {
        state.updatePasswordLoading = true;
      })
      .addCase(userUpdatePasswordAsync.fulfilled, (state) => {
        state.updatePasswordLoading = false;
      })
      .addCase(userUpdatePasswordAsync.rejected, (state) => {
        state.updatePasswordLoading = false;
      });
  },
});

export default resourceSlice;
